import { BetaChip } from 'shared/components/chips/BetaChip';
import { useMediaQuery } from 'shared/hooks/dom';

import { Bot } from './components/Bot';
import { HistoryButton } from './components/HistoryButton';
import { Wrapper } from './components/Wrapper';
import { GRID_AREA_CHIP } from './constants';

import type { FC } from 'react';

export const Header: FC = () => {
  const matches = useMediaQuery('lg', 'down');

  return (
    <Wrapper>
      <Bot />
      <BetaChip sx={{ gridArea: GRID_AREA_CHIP, width: 'fit-content' }} />
      {matches && <HistoryButton />}
    </Wrapper>
  );
};
